import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CreditCardCalculator from './pages/CreditCardCalculator';
import SnowballCalculator from './pages/SnowballCalculator';
import AvalancheCalculator from './pages/AvalancheCalculator';
import DebtRepaymentCalculator from './pages/DebtRepaymentCalculator';
import SalirDeDeudas from './pages/SalirDeDeudas';
import CalculadoraDeDeudas from './pages/CalculadoraDeDeudas';
import CalculadoraDeDividas from './pages/CalculadoraDeDividas';
import CalculateurDeDettes from './pages/CalculateurDeDettes';
import Schuldenrechner from './pages/Schuldenrechner';
import SchuldenAflossen from './pages/SchuldenAflossen';
import IndiaDebtCalculator from './pages/IndiaDebtCalculator';
import SouthAfricaDebtCalculator from './pages/SouthAfricaDebtCalculator';
import BlogIndex from './pages/blog/BlogIndex';
import DebtSnowballVsAvalanche from './pages/blog/DebtSnowballVsAvalanche';
import AverageCreditCardDebtCanada from './pages/blog/AverageCreditCardDebtCanada';
import PayOff10000CreditCardDebtUK from './pages/blog/PayOff10000CreditCardDebtUK';
import PayOffDebtLowIncome from './pages/blog/PayOffDebtLowIncome';
import HowToPayOffCreditCardDebt from './pages/blog/HowToPayOffCreditCardDebt';
import HowToGetOutOfDebtFast from './pages/blog/HowToGetOutOfDebtFast';
import PayOffDebtOrInvest from './pages/blog/PayOffDebtOrInvest';
import HowLongToPayOffDebt from './pages/blog/HowLongToPayOffDebt';
import DebtConsolidationProsCons from './pages/blog/DebtConsolidationProsCons';
import StudentLoanCalculator from './pages/StudentLoanCalculator';
import PersonalLoanCalculator from './pages/PersonalLoanCalculator';
import CarLoanCalculator from './pages/CarLoanCalculator';
import TermsPage from './pages/TermsPage';
import SuccessRedirect from './pages/SuccessRedirect';
import Calculator from './components/Calculator';

function LocaleHomePage() {
  const { locale } = useParams();
  return <Calculator locale={locale} />;
}

function LocaleCalculatorPage({ defaultMethod, defaultDebtType }) {
  const { locale } = useParams();
  return (
    <Calculator
      locale={locale}
      defaultMethod={defaultMethod || 'avalanche'}
      defaultDebtType={defaultDebtType || null}
      showHelmet={true}
      showHeader={true}
    />
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/credit-card-payoff-calculator/" element={<CreditCardCalculator />} />
        <Route path="/debt-snowball-calculator/" element={<SnowballCalculator />} />
        <Route path="/debt-avalanche-calculator/" element={<AvalancheCalculator />} />
        <Route path="/debt-repayment-calculator/" element={<DebtRepaymentCalculator />} />
        <Route path="/salir-de-deudas/" element={<SalirDeDeudas />} />
        <Route path="/calculadora-de-deudas/" element={<CalculadoraDeDeudas />} />
        <Route path="/calculadora-de-dividas/" element={<CalculadoraDeDividas />} />
        <Route path="/calculateur-de-dettes/" element={<CalculateurDeDettes />} />
        <Route path="/schuldenrechner/" element={<Schuldenrechner />} />
        <Route path="/schulden-aflossen/" element={<SchuldenAflossen />} />
        <Route path="/in/" element={<IndiaDebtCalculator />} />
        <Route path="/za/" element={<SouthAfricaDebtCalculator />} />
        <Route path="/blog/" element={<BlogIndex />} />
        <Route path="/blog/debt-snowball-vs-avalanche/" element={<DebtSnowballVsAvalanche />} />
        <Route path="/blog/average-credit-card-debt-canada/" element={<AverageCreditCardDebtCanada />} />
        <Route path="/blog/pay-off-10000-credit-card-debt-uk/" element={<PayOff10000CreditCardDebtUK />} />
        <Route path="/blog/pay-off-debt-low-income/" element={<PayOffDebtLowIncome />} />
        <Route path="/blog/how-to-pay-off-credit-card-debt/" element={<HowToPayOffCreditCardDebt />} />
        <Route path="/blog/how-to-get-out-of-debt-fast/" element={<HowToGetOutOfDebtFast />} />
        <Route path="/blog/pay-off-debt-or-invest/" element={<PayOffDebtOrInvest />} />
        <Route path="/blog/how-long-to-pay-off-debt/" element={<HowLongToPayOffDebt />} />
        <Route path="/blog/debt-consolidation-pros-cons/" element={<DebtConsolidationProsCons />} />
        <Route path="/student-loan-payoff-calculator/" element={<StudentLoanCalculator />} />
        <Route path="/personal-loan-payoff-calculator/" element={<PersonalLoanCalculator />} />
        <Route path="/car-loan-payoff-calculator/" element={<CarLoanCalculator />} />
        <Route path="/terms/" element={<TermsPage />} />
        <Route path="/success" element={<SuccessRedirect />} />
        {/* i18n locale routes — locale-prefixed calculator pages */}
        <Route path="/:locale/credit-card-payoff-calculator/" element={<LocaleCalculatorPage defaultDebtType="Credit Card" />} />
        <Route path="/:locale/debt-snowball-calculator/" element={<LocaleCalculatorPage defaultMethod="snowball" />} />
        <Route path="/:locale/debt-avalanche-calculator/" element={<LocaleCalculatorPage defaultMethod="avalanche" />} />
        <Route path="/:locale/debt-repayment-calculator/" element={<LocaleCalculatorPage />} />
        <Route path="/:locale/student-loan-payoff-calculator/" element={<LocaleCalculatorPage defaultDebtType="Student Loan" />} />
        <Route path="/:locale/personal-loan-payoff-calculator/" element={<LocaleCalculatorPage defaultDebtType="Personal Loan" />} />
        <Route path="/:locale/car-loan-payoff-calculator/" element={<LocaleCalculatorPage defaultDebtType="Car Loan" />} />
        {/* i18n locale home — pass locale from URL to Calculator */}
        <Route path="/:locale/" element={<LocaleHomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
